<!-- Layers Toggle Button -->
<div class="custom-map-control">
    <button (click)="toggleMenu()" class="layers-button">
        <span class="material-icons">layers</span>
    </button>

    <!-- Expandable Layers Menu -->
    <div class="layers-menu" [class.open]="isExpanded">
        <label *ngFor="let layer of layers">
            <input type="checkbox" [(ngModel)]="layer.enabled" (change)="toggleLayer(layer)" />
            {{ layer.name }}
        </label>
    </div>
</div>